import React, { useState } from 'react';
import {
  FOUNDER_SITE_URL,
  FOUNDER_AVATAR_PATH,
  FOUNDER_NAME,
  FOUNDER_TAGLINE,
} from '../constants/founder';

type FounderLinkProps = {
  /** Larger padding and avatar in the welcome modal */
  variant?: 'modal' | 'footer';
  onNavigate?: () => void;
};

const FounderLink: React.FC<FounderLinkProps> = ({ variant = 'modal', onNavigate }) => {
  const [imgError, setImgError] = useState(false);
  const isFooter = variant === 'footer';

  return (
    <a
      href={FOUNDER_SITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onNavigate}
      className={
        isFooter
          ? 'flex items-center gap-3 p-2 sm:p-3 rounded-xl border border-white/[0.08] bg-tech-elevated/60 hover:border-tech-cyan/25 transition-colors group max-w-md'
          : 'flex items-center gap-3 p-3 rounded-xl border border-white/[0.08] bg-tech-elevated/50 hover:border-tech-cyan/25 transition-colors group'
      }
      aria-label={`${FOUNDER_NAME} — open portfolio`}
    >
      {!imgError ? (
        <img
          src={FOUNDER_AVATAR_PATH}
          alt=""
          width={isFooter ? 36 : 40}
          height={isFooter ? 36 : 40}
          className={
            isFooter
              ? 'w-9 h-9 rounded-full object-cover border border-tech-border group-hover:border-tech-cyan/40 flex-shrink-0'
              : 'w-10 h-10 rounded-full object-cover border border-tech-border group-hover:border-tech-cyan/40'
          }
          onError={() => setImgError(true)}
        />
      ) : (
        <div
          className={
            isFooter
              ? 'w-9 h-9 rounded-full bg-gradient-to-br from-tech-cyan to-tech-accent flex items-center justify-center text-tech-darker text-xs font-bold border border-tech-border flex-shrink-0'
              : 'w-10 h-10 rounded-full bg-gradient-to-br from-tech-cyan to-tech-accent flex items-center justify-center text-tech-darker text-sm font-bold border border-tech-border'
          }
        >
          NG
        </div>
      )}
      <div className="min-w-0 flex-1 text-left">
        <div
          className={
            isFooter
              ? 'font-medium text-tech-text group-hover:text-tech-cyan transition-colors text-sm'
              : 'font-medium text-tech-text group-hover:text-tech-cyan transition-colors'
          }
        >
          {FOUNDER_NAME}
        </div>
        <div
          className={`text-tech-text-muted truncate ${isFooter ? 'text-xs' : 'text-xs'}`}
        >
          {FOUNDER_TAGLINE}
        </div>
      </div>
      <span className="text-tech-cyan text-sm flex-shrink-0">Open →</span>
    </a>
  );
};

export default FounderLink;
